import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BlacklistMutationKeys } from '../../../keys'
import {
	UpdateBlacklistReportRequest,
	UpdateBlacklistReportResponse,
} from '../../../type'
import { updateBlacklistReport } from '../../services'

interface UseMutationUpdateBlacklistReportProps {
	id: string
	payload: UpdateBlacklistReportRequest
}

export default function useMutationUpdateBlacklistReport(
	props?: UseBaseMutationOptions<
		UpdateBlacklistReportResponse,
		UseMutationUpdateBlacklistReportProps
	>,
) {
	return useMutation({
		mutationKey: [BlacklistMutationKeys.UpdateBlacklistReport],
		mutationFn: ({ id, payload }) => {
			return updateBlacklistReport(id, payload)
		},
		...props,
	})
}
